import { Button } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import React from "react";

const ButtonTheme = ({ btnText, chakraProps, location, handleButtonClick }) => {
  const history = useHistory();

  return (
    <Button
      fontWeight={"400"}
      h={"48px"}
      w={{ sm: "208px", base: "100%" }}
      borderRadius={"30px"}
      onClick={() => handleButtonClick()}
      bgColor={"BrightTurquoise"}
      textTransform={"math-auto"}
      border={"1px solid transparent"}
      _hover={{
        border: "1px solid transparent",
        transform: "translateY(-2px)",
        boxShadow: "lg",
        "svg path": {
          fill: "white",
        },
      }}
      {...chakraProps}
    >
      {btnText}
    </Button>
  );
};

export default ButtonTheme;
